import {AfterViewInit, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {RadiographyResultModel} from '../../shared/models/radiography-result.model';

@Component({
  selector: 'app-radiography-print',
  templateUrl: './radiography-print.component.html',
  styleUrls: ['./radiography-print.component.scss'],
})
export class RadiographyPrintComponent implements OnInit  {

  @Input() radiographyResultModel: RadiographyResultModel;

  constructor() {
  }

  ngOnInit() {
  }

}
